

/* Price and availability are rendered from the selected Shopify variant and selling plan. */
(function(){
  'use strict';
  function init(root){
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const $ = (s) => root.querySelector(s);
  const $$ = (s) => [...root.querySelectorAll(s)];
  const fmt = (cents) => new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',minimumFractionDigits:cents%100===0?0:2,maximumFractionDigits:2}).format(cents/100);
  const config = window.EVORI_HERO_CONFIG || {};
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const motion = () => reducedMotion.matches ? 'auto' : 'smooth';
  const cards = $$('.evh-card');
  const subscribe = $('[data-subscribe]');
  const images = JSON.parse($('[data-evh-images]').textContent);
  images.bottle = $('.evh-slide img').src;
  $$('img[data-asset]').forEach(img => {img.src=images[img.dataset.asset];});
  const rail = $('.evh-rail'), thumbRail=$('.evh-thumbs');
  // Optional complete image list: any positive count, no five-image limit.
  const galleryImages=Array.isArray(config.galleryImages)?config.galleryImages.flatMap((entry)=>{
    if(!entry || typeof entry.src!=='string' || !entry.src.trim())return [];
    try{
      const url=new URL(entry.src,location.href);
      if(!['https:','http:','blob:'].includes(url.protocol) && !/^data:image\//i.test(entry.src))return [];
      return [{src:url.href,alt:typeof entry.alt==='string'?entry.alt:'EVORÍ product image',caption:typeof entry.caption==='string'?entry.caption:'',fit:entry.fit==='contain'?'contain':'cover'}];
    }catch{return [];}
  }):[];
  if(galleryImages.length){
    rail.replaceChildren();thumbRail.replaceChildren();
    galleryImages.forEach((entry,i)=>{
      const slide=document.createElement('figure');slide.className='evh-slide';
      slide.dataset.slide=String(i);slide.dataset.photoCaption=entry.caption;slide.dataset.fit=entry.fit;
      slide.setAttribute('role','group');slide.setAttribute('aria-roledescription','slide');slide.setAttribute('aria-label',(i+1)+' of '+galleryImages.length);
      const img=document.createElement('img');img.src=entry.src;img.alt=entry.alt;img.width=1400;img.height=1400;img.draggable=false;img.decoding='async';img.loading=i===0?'eager':'lazy';if(i===0)img.fetchPriority='high';slide.append(img);rail.append(slide);
      const thumb=document.createElement('button');thumb.type='button';thumb.className='evh-thumb';thumb.dataset.thumb=String(i);thumb.setAttribute('aria-label','View image '+(i+1)+(entry.caption?': '+entry.caption:''));thumb.setAttribute('aria-controls',rail.id);
      const thumbnail=document.createElement('img');thumbnail.src=entry.src;thumbnail.alt='';thumbnail.width=180;thumbnail.height=180;thumbnail.draggable=false;thumbnail.decoding='async';thumbnail.loading='lazy';thumb.append(thumbnail);thumbRail.append(thumb);
    });
  }
  const slides=$$('.evh-slide'), thumbs=$$('[data-thumb]');
  slides.forEach((slide,index)=>{slide.dataset.slide=String(index);slide.setAttribute('aria-label',(index+1)+' of '+slides.length);});
  thumbs.forEach((thumb,index)=>{thumb.dataset.thumb=String(index);});
  const captions=slides.map(slide=>slide.dataset.photoCaption||'');
  thumbs.forEach((thumb,index)=>thumb.setAttribute('aria-label','View image '+(index+1)+(captions[index]?': '+captions[index]:'')));
  const lightbox = $('[data-lightbox]');
  let activeImage = 0, navigationTarget = null, navigationTimer = 0;

  function revealThumbnail(index){
    const button=thumbs[index],box=thumbRail.getBoundingClientRect(),item=button.getBoundingClientRect();
    if(item.left<box.left+5)thumbRail.scrollBy({left:item.left-box.left-5,behavior:motion()});
    else if(item.right>box.right-5)thumbRail.scrollBy({left:item.right-box.right+5,behavior:motion()});
  }

  function cancelNavigation(){
    navigationTarget=null;
    clearTimeout(navigationTimer);
  }

  function activateImage(index){
    activeImage=Math.max(0,Math.min(slides.length-1,index));
    thumbs.forEach((el,i)=>el.setAttribute('aria-current',String(i===activeImage)));
    slides.forEach((el,i)=>el.classList.toggle('is-active',i===activeImage));
    $('[data-caption]').textContent=captions[activeImage];
    $('[data-count]').textContent=String(activeImage+1).padStart(2,'0')+' / '+String(slides.length).padStart(2,'0');
    $('[data-gallery-status]').textContent='Image '+(activeImage+1)+' of '+slides.length+'. '+captions[activeImage];
    revealThumbnail(activeImage);
    if(lightbox.open) renderLightbox();
  }
  activateImage(0);
  $$('[data-prev],[data-next],[data-lightbox-prev],[data-lightbox-next]').forEach(el=>{el.hidden=slides.length<2;});
  function goToImage(index){
    const i=(index+slides.length)%slides.length;
    clearTimeout(navigationTimer);
    navigationTarget=i;
    activateImage(i);
    rail.scrollTo({left:i*rail.clientWidth,behavior:lightbox.open?'instant':motion()});
    navigationTimer=setTimeout(()=>{
      cancelNavigation();
      activateImage(Math.round(rail.scrollLeft/rail.clientWidth));
    },1000);
  }
  let scrollFrame=0;
  rail.addEventListener('scroll',()=>{
    cancelAnimationFrame(scrollFrame);
    scrollFrame=requestAnimationFrame(()=>{
      if(navigationTarget!==null){
        if(Math.abs(rail.scrollLeft-navigationTarget*rail.clientWidth)>2)return;
        cancelNavigation();
      }
      activateImage(Math.round(rail.scrollLeft/rail.clientWidth));
    });
  },{passive:true});
  rail.addEventListener('wheel',cancelNavigation,{passive:true});
  rail.addEventListener('touchstart',cancelNavigation,{passive:true});
  thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>goToImage(i)));
  $('[data-prev]').addEventListener('click',()=>goToImage(activeImage-1));
  $('[data-next]').addEventListener('click',()=>goToImage(activeImage+1));
  rail.addEventListener('keydown',e=>{
    if(e.key==='ArrowRight'){e.preventDefault();goToImage(activeImage+1);}
    if(e.key==='ArrowLeft'){e.preventDefault();goToImage(activeImage-1);}
    if(e.key==='Home'){e.preventDefault();goToImage(0);}
    if(e.key==='End'){e.preventDefault();goToImage(slides.length-1);}
  });
  let drag=null;
  rail.addEventListener('pointerdown',e=>{
    if(e.pointerType!=='mouse'||e.button!==0)return;
    cancelNavigation();
    rail.scrollTo({left:rail.scrollLeft,behavior:'instant'});
    drag={x:e.clientX,left:rail.scrollLeft};rail.classList.add('is-dragging');rail.setPointerCapture(e.pointerId);
  });
  rail.addEventListener('pointermove',e=>{if(drag){e.preventDefault();rail.scrollLeft=drag.left+drag.x-e.clientX;}});
  function endDrag(){if(!drag)return;drag=null;rail.classList.remove('is-dragging');goToImage(Math.round(rail.scrollLeft/rail.clientWidth));}
  rail.addEventListener('pointerup',endDrag);rail.addEventListener('pointercancel',endDrag);
  if('ResizeObserver' in window)new ResizeObserver(()=>{rail.scrollTo({left:activeImage*rail.clientWidth,behavior:'instant'});}).observe(rail);

  function renderLightbox(){
    const photo=slides[activeImage].querySelector('img');
    $('[data-lightbox-image]').src=photo.src;$('[data-lightbox-image]').alt=photo.alt;
    $('[data-lightbox-caption]').textContent=captions[activeImage];
  }
  $('[data-zoom]').addEventListener('click',()=>{renderLightbox();lightbox.showModal();});
  $('[data-close-lightbox]').addEventListener('click',()=>lightbox.close());
  $('[data-lightbox-prev]').addEventListener('click',()=>goToImage(activeImage-1));
  $('[data-lightbox-next]').addEventListener('click',()=>goToImage(activeImage+1));
  lightbox.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();goToImage(activeImage+1);}if(e.key==='ArrowLeft'){e.preventDefault();goToImage(activeImage-1);}});
  $$('dialog').forEach(dialog=>dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}}));

  const isReady = (card) => card.dataset[subscribe.checked ? 'subReady' : 'oneReady'] === 'true';
  function selectAvailable(){
    const available = cards.filter(isReady);
    cards.forEach(card => {
      const ready = isReady(card);
      card.hidden = !ready;
      card.querySelector('input').disabled = !ready;
    });
    const chosen = available.find(card => card.querySelector('input').checked) || available[0];
    cards.forEach(card => {
      card.querySelector('input').checked = card === chosen;
      card.classList.toggle('is-selected', card === chosen);
    });
    $('[data-add]').disabled = !chosen || root.dataset.offersVerified !== 'true';
    if (root.dataset.offersVerified !== 'true') $('[data-cart-status]').textContent = 'These offers are being prepared. Please use the regular product page until checkout is verified.';
    else if (!chosen) $('[data-cart-status]').textContent = 'This purchase option is not available yet.';
    return chosen;
  }
  function selection(){
    const card = selectAvailable();
    if (!card) return null;
    const quantity = Number(card.dataset.bottles);
    const subscribed = subscribe.checked;
    const total = Number(card.dataset[subscribed ? 'subCents' : 'baseCents']);
    return {bundle:card.dataset.plan,bottles:quantity,sizeMl:50,purchaseType:subscribed?'subscription':'one-time',currency:'USD',totalCents:total,unitCents:total/quantity,oneTimeBundleCents:Number(card.dataset.baseCents),retailValueCents:Number(card.dataset.retailCents),renewalDays:subscribed?Number(card.dataset.days):null,variantId:Number(card.dataset[subscribed ? 'subVariantId' : 'oneVariantId']),cartQuantity:Number(card.dataset[subscribed ? 'subQuantity' : 'oneQuantity']),sellingPlanId:subscribed?Number(card.dataset.sellingPlanId):null,shippingIncluded:true};
  }
  function renderPrices(animate){
    selectAvailable();
    cards.forEach(card=>{
      if (!isReady(card)) return;
      const qty=Number(card.dataset.bottles);
      const total=Number(card.dataset[subscribe.checked ? 'subCents' : 'baseCents']);
      const retail=Number(card.dataset.retailCents);
      card.classList.toggle('is-selected',card.querySelector('input').checked);
      card.querySelector('[data-unit]').textContent=fmt(total/qty);
      card.querySelector('[data-unit-was]').textContent=fmt(retail/qty);
      card.querySelector('[data-unit-was]').hidden=total>=retail;
      card.querySelector('[data-charge]').textContent=fmt(total);
      const save=card.querySelector('[data-saving]'),percent=Math.round((1-total/retail)*100);
      save.textContent='Save '+percent+'%';save.hidden=percent===0;
      if(animate&&!reducedMotion.matches){const p=card.querySelector('.evh-price');p.classList.remove('is-updating');void p.offsetWidth;p.classList.add('is-updating');}
    });
    const s=selection();
    if (!s) {
      $('[data-total]').textContent='Unavailable';
      $('[data-add-label]').textContent='Currently unavailable';
      return;
    }
    $('[data-total]').textContent=fmt(s.totalCents);
    $('[data-total-was]').textContent=fmt(s.retailValueCents);
    $('[data-total-comparison]').hidden=s.retailValueCents===s.totalCents;
    const saving=s.retailValueCents-s.totalCents;
    $('[data-total-saving]').textContent=saving>0?'You save '+fmt(saving)+' · '+Math.round(saving/s.retailValueCents*100)+'%':'One bottle. One payment.';
    $('[data-total-detail]').textContent=s.bottles+' full-size '+(s.bottles===1?'bottle':'bottles')+' · shipped together'+(s.renewalDays?' every '+(s.renewalDays/30)+' months':'');
    $('[data-add-label]').textContent=($('[data-add]').dataset.buttonLabel || 'Add to cart')+' — '+fmt(s.totalCents);
    const billing=$('[data-billing]');billing.replaceChildren();
    const strong=document.createElement('strong');
    strong.textContent=billing.dataset.shipping || 'Free shipping.';
    const recurring=s.renewalDays?' '+fmt(s.totalCents)+' every '+(s.renewalDays/30)+' months until canceled.':'';
    billing.append(strong,document.createTextNode(recurring+' '+(billing.dataset.tax || 'Applicable tax calculated at checkout.')));
    if (root.dataset.offersVerified === 'true') $('[data-cart-status]').textContent='';
    root.dispatchEvent(new CustomEvent('evori:selection-change',{bubbles:true,detail:s}));
  }
  cards.forEach(card=>card.querySelector('input').addEventListener('change',()=>renderPrices(false)));
  subscribe.addEventListener('change',()=>renderPrices(true));
  if (!cards.some(card => card.dataset.subReady === 'true')) {
    subscribe.checked=false;
    subscribe.disabled=true;
    subscribe.closest('.evh-subscribe').hidden=true;
  }
  renderPrices(false);

  $('[data-add]').addEventListener('click',async()=>{
    const s=selection();
    if (root.dataset.offersVerified !== 'true' || !s || !s.variantId || (s.purchaseType==='subscription' && !s.sellingPlanId)) return;
    const button=$('[data-add]');button.disabled=true;button.setAttribute('aria-busy','true');
    $('[data-cart-status]').textContent='Adding your selection…';
    const drawer=document.querySelector('cart-drawer.evori-cart-drawer, cart-drawer');
    if (drawer?.setActiveElement) drawer.setActiveElement(button);
    try {
      const item={id:s.variantId,quantity:s.cartQuantity};
      if (s.sellingPlanId) item.selling_plan=s.sellingPlanId;
      const payload={items:[item]};
      if (drawer?.getSectionsToRender) {
        payload.sections=drawer.getSectionsToRender().map(section=>section.id);
        payload.sections_url=location.pathname;
      }
      const response=await fetch(window.routes?.cart_add_url || '/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify(payload)});
      const state=await response.json();
      if (!response.ok || state.status) throw new Error(state.description || state.message || 'Could not add this item.');
      if (drawer?.renderContents && state.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(state);
      } else {
        location.assign(window.routes?.cart_url || '/cart');
        return;
      }
      $('[data-cart-status]').textContent='Added to your cart.';
    }
    catch(error){$('[data-cart-status]').textContent=error?.message || 'We couldn’t add your selection. Please try again.';console.error('EVORI cart:',error);}
    finally{button.disabled=false;button.removeAttribute('aria-busy');}
  });
  // Native films: editable through EVORI_HERO_CONFIG.videos, no third-party embed.
  const filmRegion=$('[data-films]');
  const filmRail=$('[data-film-rail]');
  const defaultFilms=JSON.parse($('[data-evh-videos]').textContent);
  const filmData=Array.isArray(config.videos)?config.videos:defaultFilms;
  const safeMediaUrl=(value)=>{if(typeof value!=='string'||!value.trim())return null;try{const u=new URL(value,location.href);return /^(https?:|data:|blob:)$/.test(u.protocol)?u.href:null;}catch{return null;}};
  if(config.expert && typeof config.expert==='object'){
    const expert=config.expert;
    if(expert.text)$$('[data-expert-note]').forEach(el=>{el.textContent=expert.quote?'“'+expert.text+'”':expert.text;});
    if(expert.text && expert.approved===true)$$('[data-expert-draft]').forEach(el=>{el.hidden=true;});
    if(expert.name)$$('[data-expert-name]').forEach(el=>{el.textContent=expert.name;if(expert.profileUrl&&/^https?:\/\//i.test(expert.profileUrl))el.href=expert.profileUrl;else el.removeAttribute('href');});
    if(expert.role)$$('[data-expert-role]').forEach(el=>{el.textContent=expert.role;});
    if(expert.credential)$$('[data-expert-credential]').forEach(el=>{el.textContent=expert.credential;});
    if(safeMediaUrl(expert.portrait))$$('.evh-expert-portrait').forEach(el=>{el.src=safeMediaUrl(expert.portrait);el.alt=expert.name||'Expert portrait';});
  }
  const filmPlayers=[];
  filmData.forEach((entry,index)=>{
    const src=safeMediaUrl(entry.src);if(!src)return;
    const card=document.createElement('article');card.className='evh-film-card';
    card.setAttribute('aria-label',entry.title||'EVORÍ video '+(index+1));
    const poster=document.createElement('img');poster.className='evh-film-poster';poster.alt='';poster.draggable=false;poster.loading='lazy';
    poster.src=safeMediaUrl(entry.poster)||images.application;poster.style.objectPosition=entry.position||'50% 50%';card.append(poster);
    const video=document.createElement('video');video.className='evh-film-video';video.preload='none';video.playsInline=true;video.controls=false;video.muted=true;video.defaultMuted=true;video.loop=true;
    video.setAttribute('muted','');video.setAttribute('loop','');video.disablePictureInPicture=true;
    video.setAttribute('playsinline','');video.setAttribute('aria-label',entry.title||'EVORÍ video');video.tabIndex=-1;
    video.style.objectFit=entry.fit==='cover'?'cover':'contain';
    if(entry.captions){const track=document.createElement('track');track.kind='captions';track.src=safeMediaUrl(entry.captions)||'';track.srclang=entry.language||'en';track.label=entry.captionLabel||'English';video.append(track);}
    card.append(video);filmPlayers.push(video);
    const button=document.createElement('button');button.type='button';button.className='evh-film-play';button.setAttribute('aria-label','Play '+(entry.title||'EVORÍ video '+(index+1)));
    button.innerHTML='<span class="evh-film-play-mark" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="m8 5 11 7-11 7Z"/></svg></span><span class="evh-film-label"><small>EVORÍ films</small><strong></strong></span>';
    button.querySelector('strong').textContent=entry.title||'See it in action';card.append(button);
    let errorMessage=null;
    const showError=()=>{
      if(errorMessage)return;
      errorMessage=document.createElement('div');errorMessage.className='evh-film-error';errorMessage.setAttribute('role','status');errorMessage.textContent='This video couldn’t load.';
      const a=document.createElement('a');a.href=src;a.target='_blank';a.rel='noopener';a.textContent='Open video';errorMessage.append(a);card.append(errorMessage);
    };
    button.addEventListener('click',async()=>{
      if(filmRail.dataset.dragged==='true')return;
      if(errorMessage){errorMessage.remove();errorMessage=null;}
      card.classList.add('is-started');video.tabIndex=0;
      if(!video.getAttribute('src')){video.src=src;video.load();}
      try{await video.play();video.focus({preventScroll:true});}catch(error){if(error.name!=='AbortError')showError();}
    });
    video.startSilentFilm=()=>{
      if(video.dataset.userPaused==='true'||document.hidden)return;
      video.muted=true;
      if(!video.getAttribute('src'))video.src=src;
      video.play().then(()=>{card.classList.add('is-started');video.tabIndex=0;}).catch(()=>{});
    };
    // Keep playback controllable without displaying the native audio/control bar.
    const toggleFilm=()=>{if(video.paused){video.dataset.userPaused='false';video.startSilentFilm();}else{video.dataset.userPaused='true';video.pause();}};
    video.setAttribute('role','button');
    const updateFilmLabel=()=>video.setAttribute('aria-label',(video.paused?'Play ':'Pause ')+(entry.title||'EVORÍ video'));
    video.addEventListener('click',toggleFilm);
    video.addEventListener('keydown',e=>{if(e.key===' '||e.key==='Enter'){e.preventDefault();toggleFilm();}});
    video.addEventListener('play',updateFilmLabel);video.addEventListener('pause',updateFilmLabel);
    video.addEventListener('error',showError);
    filmRail.append(card);
  });
  if(!filmPlayers.length)filmRegion.hidden=true;
  function pauseFilms(){filmPlayers.forEach(v=>v.pause());}
  function moveFilms(direction){
    const step=(filmRail.firstElementChild?.getBoundingClientRect().width||200)+16;
    const max=filmRail.scrollWidth-filmRail.clientWidth;
    let target=filmRail.scrollLeft+direction*step;
    if(direction>0&&filmRail.scrollLeft>=max-3)target=0;
    else if(direction<0&&filmRail.scrollLeft<=3)target=max;
    filmRail.scrollTo({left:Math.max(0,Math.min(max,target)),behavior:motion()});
  }
  $('[data-film-prev]').addEventListener('click',()=>moveFilms(-1));
  $('[data-film-next]').addEventListener('click',()=>moveFilms(1));
  filmRail.addEventListener('keydown',e=>{
    if(e.target!==filmRail)return;
    if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();moveFilms(e.key==='ArrowRight'?1:-1);}
    if(e.key==='Home'||e.key==='End'){e.preventDefault();filmRail.scrollTo({left:e.key==='Home'?0:filmRail.scrollWidth,behavior:motion()});}
  });
  let filmDrag=null;
  filmRail.addEventListener('pointerdown',e=>{
    if(e.pointerType!=='mouse'||e.button!==0||e.target.closest('video,a'))return;
    filmDrag={id:e.pointerId,x:e.clientX,left:filmRail.scrollLeft,active:false};filmRail.dataset.dragged='false';
  });
  filmRail.addEventListener('pointermove',e=>{
    if(!filmDrag||e.pointerId!==filmDrag.id)return;
    if(!(e.buttons&1)){stopFilmDrag();return;}
    const delta=e.clientX-filmDrag.x;
    if(Math.abs(delta)>6&&!filmDrag.active){filmDrag.active=true;filmRail.dataset.dragged='true';filmRail.classList.add('is-dragging');filmRail.setPointerCapture(e.pointerId);}
    if(filmDrag.active){e.preventDefault();filmRail.scrollLeft=filmDrag.left-delta;}
  });
  const stopFilmDrag=()=>{filmDrag=null;filmRail.classList.remove('is-dragging');setTimeout(()=>{filmRail.dataset.dragged='false';},120);};
  window.addEventListener('pointerup',stopFilmDrag);window.addEventListener('pointercancel',stopFilmDrag);
  filmRail.addEventListener('click',e=>{if(filmRail.dataset.dragged==='true'){e.preventDefault();e.stopImmediatePropagation();}},true);
  if('IntersectionObserver' in window){
    const filmObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{const video=entry.target;video.dataset.visible=String(entry.isIntersecting&&entry.intersectionRatio>=.25);if(video.dataset.visible==='true')video.startSilentFilm();else video.pause();}),{threshold:[0,.25]});
    filmPlayers.forEach(video=>filmObserver.observe(video));
  }
  document.addEventListener('visibilitychange',()=>{if(document.hidden)pauseFilms();else filmPlayers.forEach(video=>{if(video.dataset.visible==='true')video.startSilentFilm();});});
  // Ensure the expert note can scroll into view when the sticky gallery exceeds the viewport.
  const mediaColumn=$('.evh-media');
  const positionMedia=()=>{mediaColumn.style.top=window.innerWidth>900?Math.min(26,window.innerHeight-mediaColumn.offsetHeight-24)+'px':'';};
  if('ResizeObserver' in window)new ResizeObserver(positionMedia).observe(mediaColumn);
  window.addEventListener('resize',positionMedia,{passive:true});positionMedia();

  // Resolve the source page's links against either host theme, then the live reference.
  const detailDestinations={
    '#ritual':['#ritual','#routine','#rout'],
    '#ingredients':['#ingredients','#ing']
  };
  $$('.evh-questions a').forEach(link=>{
    const target=link.getAttribute('href');const choices=detailDestinations[target];if(!choices)return;
    const local=choices.find(id=>document.querySelector(id));
    if(local)link.setAttribute('href',local);
    else{link.href='https://www.evoricollective.com/products/advanced-anti-aging-serum?view=test-1'+(target==='#ritual'?'#routine':'#ingredients');link.target='_blank';link.rel='noopener';}
  });

  }
  document.querySelectorAll('[data-evori-hero]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-evori-hero]').forEach(init));
})();
